import { Controller } from "@hotwired/stimulus"

// Pokazuje wybór działu tylko dla poziomów widoczności bazy wiedzy, na których dział
// ma znaczenie (users, admins). Initial state ustawia ERB klasą "hidden".
export default class extends Controller {
  static targets = ["levelSelect", "departmentField"]
  static values = { withDepartment: Array }

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasDepartmentFieldTarget) return

    const visible = this.withDepartmentValue.includes(this.levelSelectTarget.value)
    this.departmentFieldTarget.classList.toggle("hidden", !visible)
  }
}
